import appConfig from '@/config/applicationConfig.js'

export const NotificationServiceMixim = {
  methods: {
    getNotifications (params, unread) {
      let from = params.from || 0
      let size = params.size || 10
      let url = ''
      if (unread) {
        url = `${appConfig.API_END_POINT}/notifications?from=0&size=1&mode=INBOX&read=false`
      } else {
        url = `${appConfig.API_END_POINT}/notifications?from=${from}&size=${size}&mode=INBOX&sortBy=creationDate&sortOrder=desc`
      }
      return this.$http.get(
        url,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.access_token}`
          }
        }
      )
    },
    markNotificationRead (notificationId) {
      return this.$http.post(
        `${appConfig.API_END_POINT}/notifications/${notificationId}/read`, '',
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.access_token}`
          }
        }
      )
    }
  }
}
